import errorManager from '@/rollbar.js';

const changeRescity = (selector) => {
  updateAslsList(selector);
};

const updateAslsList = (selector) => {
  const country_id = $(selector.search_all_asls).prop('checked') ? null : $(selector.rescity).val();
  eventBus.$emit('rescityChanged', { detail: { country_id: country_id } });
};

const setListener = (selector) => {
  $(selector.rescity).on('change', (e) => {
    $(selector.search_all_asls).prop('checked', $(selector.rescity).val() == '');
  });

  /*****
   * added to handle jquery self update
   * because the form_for f.select change the value of the select
   * but doesn't emit the onChange event
   * *****/
  var observer = new window.MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        changeRescity(selector);
      }
    });
  });

  observer.observe($(selector.rescity)[0], {
    childList: true,
    characterData: true,
    subtree: true,
  });
  /***** *****/

  $(selector.search_all_asls).on('change', (e) => {
    updateAslsList(selector);
  });
};

const districtByAsl = (ev) => {
  const asl = $(ev.target).find('option:selected').val();
  changeUrlByMaster($('#coddistr'), asl, 'asl_id');
};

const zoneUuByRescity = (ev) => {
  const asl = $(ev.target).find('option:selected').val();
  changeUrlByMaster($('#guest_zone_uu_id'), asl, 'comune_id');
};

const zoneByDistrict = (ev) => {
  changeUrlByMaster($('#guest_zone_id'), $(ev.target).find('option:selected').val(), 'district_id');
};

const changeUrlByMaster = (selectSlave, val, paramsName) => {
  const newUrl = Utils.addGetParam(selectSlave.data('ajax--url'), paramsName, val);
  selectSlave.select2('destroy');
  selectSlave.data('ajaxUrl', newUrl);
  window.CreateSelect2.initEl(selectSlave);
};

const updateCapValue = () => {
  let street = document.getElementById('resaddress').value;
  let municipality_id = document.getElementById('rescity').value;

  if (street === '' || municipality_id === '') {
    return true;
  }

  $.ajax({
    url: '/' + window.locale + '/countries/autocomplete_cap',
    data: {
      street: street,
      municipality_id: municipality_id,
    },
    cache: false,
    type: 'GET',
    success: function (response) {
      document.getElementById('rescap').value = response;
    },
    error: function (xhr) {
      console.log('Errore nel caricamento del CAP');
    },
  });
};

const init = (selector) => {
  try {
    $(document).on('change', '#guest_asl_id', districtByAsl);
    $(document).on('change', '#coddistr', zoneByDistrict);
    $(document).on('change', '#rescity', zoneUuByRescity);

    $('#rescity').on('change', updateCapValue);
    $('#resaddress').on('change', updateCapValue);

    if (selector) {
      changeRescity(selector);
      setListener(selector);
    }
  } catch (e) {
    errorManager(e);
  }
};

window.Guest = {
  init: init,
};
